//# sourceMappingURL=ingestion_control.mjs.map
/// <reference types="./ingestion_control.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $data_point from "../../../data_types/data/data_point.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

export function fetch_data_points(source_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["data-points", source_id]),
          );
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = $ask.expect(
            _pipe$1,
            $decode.list($data_point.decoder()),
          );
          let _pipe$3 = $ask.on_success(
            _pipe$2,
            (d) => {
              dispatch(
                new $msg.ContentLibrary(
                  new $msg.ApiFetchedDataPoints(source_id, d),
                ),
              );
              return undefined;
            },
          );
          return $ask.run(_pipe$3);
        },
      );
    },
  );
}
